type Subscriber = (nowEpochSec: number) => void

class Ticker {
    private subscribers: Set<Subscriber> = new Set()
    private timerId: number | null = null

    subscribe(callback: Subscriber) {
        this.subscribers.add(callback)

        if (this.timerId === null) {
            this.start()
        }
    }

    unsubscribe(callback: Subscriber) {
        this.subscribers.delete(callback)

        if (this.subscribers.size === 0 && this.timerId !== null) {
            window.clearTimeout(this.timerId)
            this.timerId = null
        }
    }

    private start() {
        const tick = () => {
            const nowEpochSec = Math.floor(Date.now() / 1000)
            this.subscribers.forEach((callback) => callback(nowEpochSec))
            const delay = 1000 - (Date.now() % 1000)
            this.timerId = window.setTimeout(tick, delay)
        }

        tick()
    }
}

const ticker = new Ticker()

export const subscribe = (callback: Subscriber) => ticker.subscribe(callback)
export const unsubscribe = (callback: Subscriber) => ticker.unsubscribe(callback)

